// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "mlinference/internalapi/v1/mlinference.proto" (package "mlinference.internalapi.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal and private ml inference annotations RPCs and protos
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { InternalMLInferenceService } from "./mlinference";
import type { CancelEvaluationJobResponse } from "./mlinference";
import type { CancelEvaluationJobRequest } from "./mlinference";
import type { ListEvaluationJobsResponse } from "./mlinference";
import type { ListEvaluationJobsRequest } from "./mlinference";
import type { GetEvaluationJobResponse } from "./mlinference";
import type { GetEvaluationJobRequest } from "./mlinference";
import type { StartEvaluationJobResponse } from "./mlinference";
import type { StartEvaluationJobRequest } from "./mlinference";
import type { DismissJobResponse } from "./mlinference";
import type { DismissJobRequest } from "./mlinference";
import type { ListInferenceJobsResponse } from "./mlinference";
import type { ListInferenceJobsRequest } from "./mlinference";
import type { GetInferenceJobResponse } from "./mlinference";
import type { GetInferenceJobRequest } from "./mlinference";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { StartInferenceJobResponse } from "./mlinference";
import type { StartInferenceJobRequest } from "./mlinference";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service mlinference.internalapi.v1.InternalMLInferenceService
 */
export interface IInternalMLInferenceServiceClient {
    /**
     * @generated from protobuf rpc: StartInferenceJob(mlinference.internalapi.v1.StartInferenceJobRequest) returns (mlinference.internalapi.v1.StartInferenceJobResponse);
     */
    startInferenceJob(input: StartInferenceJobRequest, options?: RpcOptions): UnaryCall<StartInferenceJobRequest, StartInferenceJobResponse>;
    /**
     * @generated from protobuf rpc: GetInferenceJob(mlinference.internalapi.v1.GetInferenceJobRequest) returns (mlinference.internalapi.v1.GetInferenceJobResponse);
     */
    getInferenceJob(input: GetInferenceJobRequest, options?: RpcOptions): UnaryCall<GetInferenceJobRequest, GetInferenceJobResponse>;
    /**
     * ListInferenceJobs lists training jobs for a given dataset ID and inference status.
     *
     * @generated from protobuf rpc: ListInferenceJobs(mlinference.internalapi.v1.ListInferenceJobsRequest) returns (mlinference.internalapi.v1.ListInferenceJobsResponse);
     */
    listInferenceJobs(input: ListInferenceJobsRequest, options?: RpcOptions): UnaryCall<ListInferenceJobsRequest, ListInferenceJobsResponse>;
    /**
     * @generated from protobuf rpc: DismissJob(mlinference.internalapi.v1.DismissJobRequest) returns (mlinference.internalapi.v1.DismissJobResponse);
     */
    dismissJob(input: DismissJobRequest, options?: RpcOptions): UnaryCall<DismissJobRequest, DismissJobResponse>;
    /**
     * @generated from protobuf rpc: StartEvaluationJob(mlinference.internalapi.v1.StartEvaluationJobRequest) returns (mlinference.internalapi.v1.StartEvaluationJobResponse);
     */
    startEvaluationJob(input: StartEvaluationJobRequest, options?: RpcOptions): UnaryCall<StartEvaluationJobRequest, StartEvaluationJobResponse>;
    /**
     * @generated from protobuf rpc: GetEvaluationJob(mlinference.internalapi.v1.GetEvaluationJobRequest) returns (mlinference.internalapi.v1.GetEvaluationJobResponse);
     */
    getEvaluationJob(input: GetEvaluationJobRequest, options?: RpcOptions): UnaryCall<GetEvaluationJobRequest, GetEvaluationJobResponse>;
    /**
     * ListEvaluationJobs lists evaluation jobs for a given dataset ID.
     *
     * @generated from protobuf rpc: ListEvaluationJobs(mlinference.internalapi.v1.ListEvaluationJobsRequest) returns (mlinference.internalapi.v1.ListEvaluationJobsResponse);
     */
    listEvaluationJobs(input: ListEvaluationJobsRequest, options?: RpcOptions): UnaryCall<ListEvaluationJobsRequest, ListEvaluationJobsResponse>;
    /**
     * @generated from protobuf rpc: CancelEvaluationJob(mlinference.internalapi.v1.CancelEvaluationJobRequest) returns (mlinference.internalapi.v1.CancelEvaluationJobResponse);
     */
    cancelEvaluationJob(input: CancelEvaluationJobRequest, options?: RpcOptions): UnaryCall<CancelEvaluationJobRequest, CancelEvaluationJobResponse>;
}
/**
 * @generated from protobuf service mlinference.internalapi.v1.InternalMLInferenceService
 */
export class InternalMLInferenceServiceClient implements IInternalMLInferenceServiceClient, ServiceInfo {
    typeName = InternalMLInferenceService.typeName;
    methods = InternalMLInferenceService.methods;
    options = InternalMLInferenceService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: StartInferenceJob(mlinference.internalapi.v1.StartInferenceJobRequest) returns (mlinference.internalapi.v1.StartInferenceJobResponse);
     */
    startInferenceJob(input: StartInferenceJobRequest, options?: RpcOptions): UnaryCall<StartInferenceJobRequest, StartInferenceJobResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<StartInferenceJobRequest, StartInferenceJobResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetInferenceJob(mlinference.internalapi.v1.GetInferenceJobRequest) returns (mlinference.internalapi.v1.GetInferenceJobResponse);
     */
    getInferenceJob(input: GetInferenceJobRequest, options?: RpcOptions): UnaryCall<GetInferenceJobRequest, GetInferenceJobResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetInferenceJobRequest, GetInferenceJobResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ListInferenceJobs lists training jobs for a given dataset ID and inference status.
     *
     * @generated from protobuf rpc: ListInferenceJobs(mlinference.internalapi.v1.ListInferenceJobsRequest) returns (mlinference.internalapi.v1.ListInferenceJobsResponse);
     */
    listInferenceJobs(input: ListInferenceJobsRequest, options?: RpcOptions): UnaryCall<ListInferenceJobsRequest, ListInferenceJobsResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListInferenceJobsRequest, ListInferenceJobsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DismissJob(mlinference.internalapi.v1.DismissJobRequest) returns (mlinference.internalapi.v1.DismissJobResponse);
     */
    dismissJob(input: DismissJobRequest, options?: RpcOptions): UnaryCall<DismissJobRequest, DismissJobResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<DismissJobRequest, DismissJobResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: StartEvaluationJob(mlinference.internalapi.v1.StartEvaluationJobRequest) returns (mlinference.internalapi.v1.StartEvaluationJobResponse);
     */
    startEvaluationJob(input: StartEvaluationJobRequest, options?: RpcOptions): UnaryCall<StartEvaluationJobRequest, StartEvaluationJobResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<StartEvaluationJobRequest, StartEvaluationJobResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetEvaluationJob(mlinference.internalapi.v1.GetEvaluationJobRequest) returns (mlinference.internalapi.v1.GetEvaluationJobResponse);
     */
    getEvaluationJob(input: GetEvaluationJobRequest, options?: RpcOptions): UnaryCall<GetEvaluationJobRequest, GetEvaluationJobResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetEvaluationJobRequest, GetEvaluationJobResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ListEvaluationJobs lists evaluation jobs for a given dataset ID.
     *
     * @generated from protobuf rpc: ListEvaluationJobs(mlinference.internalapi.v1.ListEvaluationJobsRequest) returns (mlinference.internalapi.v1.ListEvaluationJobsResponse);
     */
    listEvaluationJobs(input: ListEvaluationJobsRequest, options?: RpcOptions): UnaryCall<ListEvaluationJobsRequest, ListEvaluationJobsResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListEvaluationJobsRequest, ListEvaluationJobsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CancelEvaluationJob(mlinference.internalapi.v1.CancelEvaluationJobRequest) returns (mlinference.internalapi.v1.CancelEvaluationJobResponse);
     */
    cancelEvaluationJob(input: CancelEvaluationJobRequest, options?: RpcOptions): UnaryCall<CancelEvaluationJobRequest, CancelEvaluationJobResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<CancelEvaluationJobRequest, CancelEvaluationJobResponse>("unary", this._transport, method, opt, input);
    }
}
